import React from "react";
import classnames from "classnames";
import { useRouter } from "next/navigation";

import { Action, Category } from "@/constants/events";
import {
  SEARCH_RESULT_CATEGORY_EVENT_NAMES,
  SEARCH_RESULT_CATEGORY_NAMES,
} from "@/constants/search";
import { SearchPageTypes } from "@/custom-types/Search";
import { useEventTracker } from "@/hooks/useEventTracker";
import useFilters from "@/hooks/useFilters";

import FilterPill from "../FilterPill";

type SearchFilterProps = {
  sortedCategories: SearchPageTypes[];
};

const SearchFilter = ({ sortedCategories }: SearchFilterProps) => {
  const { selectFilterValue, addFilter } = useFilters();
  const searchCategory = selectFilterValue("searchCategory");
  const searchTerm = selectFilterValue("q");
  const { publishEvent } = useEventTracker();
  const { push } = useRouter();

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    const value = e.currentTarget?.dataset?.value;

    publishEvent({
      action: Action.click,
      category: Category.productFilterBar,
      label: SEARCH_RESULT_CATEGORY_EVENT_NAMES[value || "all"],
    });

    if (value === "menuItem") {
      push(`/search/shop?q=${searchTerm}`);
    } else {
      addFilter({
        searchCategory: value,
      });
    }
  };

  return (
    <>
      <h2 className="text-xs font-bold">Show me</h2>
      <div
        className={classnames(
          "flex lg:flex-wrap overflow-x-auto py-xs md:mt-none",
        )}
      >
        <FilterPill
          isAllResults={true}
          onClick={handleClick}
          activeCategory={searchCategory}
        >
          All results
        </FilterPill>
        {sortedCategories.map((category) => {
          return (
            <FilterPill
              key={category}
              onClick={handleClick}
              activeCategory={searchCategory}
              category={category}
            >
              {SEARCH_RESULT_CATEGORY_NAMES[category] || category}
            </FilterPill>
          );
        })}
      </div>
    </>
  );
};

export default SearchFilter;
